module.exports = __webpack_public_path__ + "img/heel-strike.2bee339e.svg";